import React from "react";
import BuyButton from "./components/BuyButton";
import "./styles.css";
import billyPillowImage from "./assets/billy-pillow.png";

const App: React.FC = () => {
  return (
    <div className="app-container">
      <main className="main-content">
        <h1 className="title">BILLY•PILLOW</h1>

        <div className="pillow-image-container">
          <img
            src={billyPillowImage}
            alt="Billy Pillow"
            className="pillow-image"
          />
        </div>

        <h2 className="subtitle">limited run of 100 pillows!</h2>

        <BuyButton onSaleComplete={() => {}} />

        <div className="price">$50</div>
        <div className="shipping">(free worldwide shipping)</div>

        <div className="shipping">all profits go to the billy treasury</div>

        <div className="features">
          <div className="feature">• premium ultra soft microfiber cover</div>
          <div className="feature">• hypoallergenic filling</div>
          <div className="feature">• 25cm x 15cm (10" x 6")</div>
        </div>
      </main>
    </div>
  );
};

export default App;
